<template>
    <main class="userPerfilator-MAIN">

        <img src="../assets/sign-datos-generales.png">

        <p ref="userM" style="display:none;">M: M{{ URLUserM }}</p>

        <section>
            <p>Sobrenombre</p>
            <input type="text" v-model="formValues.nickname">
            <div class="UserPerfilator-personal-data">
                Edad
                <input type="number" v-model="formValues.age">
                Género
                <div>
                    <label><input type="radio" name="gender" value="Masculino" v-model="formValues.gender">Masculino</label>
                    <label><input type="radio" name="gender" value="Femenino" v-model="formValues.gender">Femenino</label>
                    <label><input type="radio" name="gender" value="Otro" v-model="formValues.gender">Otro</label>
                </div>
            </div>
        </section>

        <img src="../assets/sign-mis-intereses.png">

        <section>
            <p>Estilo de vida</p>
            <div class="circle-wrapper">
                <div class="circle-n-text" @click="formValues.interests.viajero = formValues.interests.viajero ? false : true"><img src="../assets/circle-viajero.png" :class="`circle-active-${formValues.interests.viajero}`"><p>Viajero</p></div>
                <div class="circle-n-text" @click="formValues.interests.foodie = formValues.interests.foodie ? false : true"><img src="../assets/circle-foodie.png" :class="`circle-active-${formValues.interests.foodie}`"><p>Foodie</p></div>
                <div class="circle-n-text" @click="formValues.interests.estudiante = formValues.interests.estudiante ? false : true"><img src="../assets/circle-estudiante.png" :class="`circle-active-${formValues.interests.estudiante}`"><p>Estudiante</p></div>
                <div class="circle-n-text" @click="formValues.interests.mascotas = formValues.interests.mascotas ? false : true"><img src="../assets/circle-mascotas.png" :class="`circle-active-${formValues.interests.mascotas}`"><p>Mascotas</p></div>
            </div>
            <div class="circle-wrapper">
                <div class="circle-n-text" @click="formValues.interests.tecnologico = formValues.interests.tecnologico ? false : true"><img src="../assets/circle-tecnologico.png" :class="`circle-active-${formValues.interests.tecnologico}`"><p>Tecnológico</p></div>
                <div class="circle-n-text" @click="formValues.interests.atleta = formValues.interests.atleta ? false : true"><img src="../assets/circle-atleta.png" :class="`circle-active-${formValues.interests.atleta}`"><p>Atleta</p></div>
                <div class="circle-n-text" @click="formValues.interests.vidaFamilia = formValues.interests.vidaFamilia ? false : true"><img src="../assets/circle-vida-familia.png" :class="`circle-active-${formValues.interests.vidaFamilia}`"><p>Vida en familia</p></div>
            </div>
        </section>

        <img src="../assets/sign-momentos-vida.png">

        <section>
            <p>Estilo de vida</p>
            <div class="circle-wrapper">
                <div class="circle-n-text" @click="formValues.lifeMoments = 'Nuevo hogar'"><img src="../assets/circle-nuevo-hogar.png" :class="`circle-active-${formValues.lifeMoments == 'Nuevo hogar'}`"><p>Nuevo hogar</p></div>
                <div class="circle-n-text" @click="formValues.lifeMoments = 'Vida en pareja'"><img src="../assets/circle-vida-pareja.png" :class="`circle-active-${formValues.lifeMoments == 'Vida en pareja'}`"><p>Vida en pareja</p></div>
                <div class="circle-n-text" @click="formValues.lifeMoments = 'Independencia'"><img src="../assets/circle-independencia.png" :class="`circle-active-${formValues.lifeMoments == 'Independencia'}`"><p>Independencia</p></div>
                <div class="circle-n-text" @click="formValues.lifeMoments = 'Nacimiento'"><img src="../assets/circle-nacimiento.png" :class="`circle-active-${formValues.lifeMoments == 'Nacimiento'}`"><p>Nacimiento</p></div>
            </div>
        </section>

        <button @click="Perfilator()">Entrar</button>

    </main>
</template>

<script>
export default {
    name: 'UserPerfilator',
    data(){
        return{
            URLUserM: '',
            formValues: {
                nickname: '',
                age: '',
                gender: '',
                interests: {
                    viajero: false,
                    foodie: false,
                    estudiante: false,
                    mascotas: false,
                    tecnologico: false,
                    atleta: false,
                    vidaFamilia: false,
                },
                lifeMoments: '',
            }
        }
    },
    methods: {
        async Perfilator() {
            const data = this.formValues;

            let mis_intereses = [];
            if(data.interests.viajero) mis_intereses.push("Viajero");
            if(data.interests.foodie) mis_intereses.push("Foodie");
            if(data.interests.estudiante) mis_intereses.push("Estudiante");
            if(data.interests.mascotas) mis_intereses.push("Mascotas");
            if(data.interests.tecnologico) mis_intereses.push("Tecnológico");
            if(data.interests.atleta) mis_intereses.push("Atleta");
            if(data.interests.vidaFamilia) mis_intereses.push("Vida en familia");

            const dataToSend = {
                m: this.$refs.userM.textContent.split(" ")[1],
                sobrenombre: data.nickname,
                edad: data.age,
                genero: data.gender,
                mis_intereses: JSON.stringify(mis_intereses || []),
                momentos_de_vida: data.lifeMoments,
                usuario_id: JSON.parse(localStorage.getItem("userData")).usuario_id
            };

            if(dataToSend.sobrenombre.trim() == "" ||
                dataToSend.edad == "" ||
                dataToSend.genero.trim() == "" ||
                dataToSend.mis_intereses == "[]" ||
                dataToSend.momentos_de_vida.trim() == ""){
                console.log("datos vacios")
                return;
            }

            try {
                const response = await fetch('https://promo-colaboradores.ideeo.mx/api/registro', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(dataToSend)
                });
                const result = await response.json();
                console.log('Respuesta del servidor:', result);
                if(result.msg == "Usuario registrado" || result.msg == "Usuario ya existe se actualizo."){
                    //localStorage.setItem("userData", JSON.stringify(result.data));
                    window.location.href = this.getFrontURL() + "/home";
                }
            } catch (error) {
                console.error('Error en la solicitud:', error);
            }
        },

        getFrontURL(){
			return window.location.origin;
		},
    },
    beforeMount(){
        window.location.href = this.getFrontURL() + "/home";
    },
    //mounted(){
    //    let params = new URLSearchParams(document.location.search);
    //    this.URLUserM = params.get("m");
    //}

}
</script>

<style scoped>
.userPerfilator-MAIN{
    width: 100%;
    min-height: 100vh;
    background-image: url('../assets/bg.webp');
    background-size: cover;
    background-position: top center;
    display: flex;
    flex-direction: column;
    align-items: center;
    font-family: 'Benton Sans BBVA Book';
    color: #0D2F6E;
    padding-bottom: 4ch;
    overflow-x: hidden;
}

.userPerfilator-MAIN > img{
    height: 3.5ch;
    margin: 4ch 0;
}

.userPerfilator-MAIN > p{
    color: #3D74D9;
    background-color: #E2EEF7;
    border-radius: 0.5ch;
    padding: 0.5ch 1ch;
    margin-top: 0;
    margin-bottom: 4ch;
}

section{
    background-color: white;
    border-radius: 1ch;
    padding: 1ch;
    width: 720px;
    max-width: calc(95vw - 2ch);
    display: flex;
    flex-direction: column;
    align-items: center;
}

.UserPerfilator-personal-data{
    display: flex;
    align-items: center;
    justify-content: center;
    width: 75%;
    margin-top: 3ch;
    margin-bottom: 2ch;
}

input{
    border: 1px solid #A8C4E5;
    padding: 1ch 0.5ch;
    border-radius: 0.5ch;
}

.UserPerfilator-personal-data input[type="number"]{
    width: 6ch;
    margin-left: 1ch;
    margin-right: auto;
}

.UserPerfilator-personal-data div{
    background-color: #cee2ff7f;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 1ch;
}

.UserPerfilator-personal-data label{
    display: flex;
    margin: 0.5ch 0.5ch;
    cursor: pointer;
}

.circle-wrapper{
    display: flex;
    align-items: center;
    justify-content: center;
}

.circle-n-text{
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 1ch 1.8ch;
}

.circle-n-text img{
    width: 8ch;
    border: 4px solid transparent;
    cursor: pointer;
}

.circle-n-text p{
    font-size: 1.4ch;
}

.circle-active-true{
    border: 4px solid #3D74D9 !important;
    border-radius: 100vw;
}

.userPerfilator-MAIN > button{
    color: white;
    background-color: #0D2F6E;
    border: none;
    padding: 1ch 4ch;
    border-radius: 5px;
    margin-top: 3ch;
    font-family: 'Benton Sans BBVA Medium';
}

/* RESPONSIVE */
@media all and (max-width:780px){

    .circle-wrapper{
        width: 100%;
        display: grid;
        grid-template-columns: 1fr 1fr;
    }

}
</style>